import { useEffect, useId, useRef } from 'react';
import { X } from 'lucide-react';
import styles from './DetailDialog.module.css';

export default function DetailDialog({ eyebrow, title, subtitle, onClose, children }) {
  const dialogRef = useRef(null);
  const titleId = useId();

  useEffect(() => {
    const dialog = dialogRef.current;
    const trigger = document.activeElement;
    if (!dialog.open) dialog.showModal();
    return () => {
      dialog.close();
      if (trigger instanceof HTMLElement && trigger.isConnected) trigger.focus();
    };
  }, []);

  return (
    <dialog ref={dialogRef} className={styles.dialog} aria-labelledby={titleId}
      onCancel={event => {
        event.preventDefault();
        event.stopPropagation();
        onClose();
      }}>
      <header className={styles.header}>
        <div>
          <p className={styles.eyebrow}>{eyebrow}</p>
          <h2 id={titleId}>{title}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        <button type="button" autoFocus className={styles.close} onClick={onClose} aria-label="Close details">
          <X size={20} aria-hidden="true" />
        </button>
      </header>
      <div className={styles.body}>{children}</div>
      <footer className={styles.footer}>
        <button type="button" className={styles.button} onClick={onClose}>Close details</button>
      </footer>
    </dialog>
  );
}